import { useMemo } from 'react';
import { Address } from 'domain/listing/value-objects';
import { formatAddress, formatStreet } from './format-address';

export interface UseAddressOptions {
  street: string;
  city?: string;
  province?: string;
  unitNumber?: string | null;
}

export interface UseAddressResult {
  formatted: string;
  street: string;
  hasValue: boolean;
}

/**
 * Hook for formatting and displaying address data.
 * 
 * Uses Address VO for validation and unit number handling.
 */
export function useAddress(options: UseAddressOptions): UseAddressResult {
  const { street, city, province, unitNumber } = options;
  
  return useMemo(() => {
    const addressVO = Address.from({ street, city: city || '', province: province || '', unitNumber: unitNumber || undefined });
    
    return {
      formatted: formatAddress({
        street: addressVO.street,
        city: addressVO.city,
        province: addressVO.province,
        unitNumber: addressVO.unitNumber,
      }),
      street: formatStreet(addressVO.street, addressVO.unitNumber),
      hasValue: addressVO.hasValue,
    };
  }, [street, city, province, unitNumber]);
}
